import { MantineThemeOverride, rem } from "@mantine/core";

import accordionTheme from "./accordion.ts";
import actionIconTheme from "./actionIcon.ts";
import appShellTheme from "./appShell.ts";
import badgeTheme from "./badge.ts";
import breadcrumbsTheme from "./breadcrumbs.ts";
import buttonTheme from "./button.ts";
import calendarTheme from "./calendar.ts";
import checkboxTheme from "./checkbox.ts";
import codeTheme from "./code.ts";
import { colors } from "./colors";
import dateInputTheme from "./dateInput.ts";
import dropzoneTheme from "./dropzone.ts";
import inputWrapperTheme from "./input.ts";
import modalTheme from "./modal.ts";
import multiSelectTheme from "./multiselect.ts";
import navLinkTheme from "./navlink.ts";
import notificationTheme from "./notification.ts";
import paginationTheme from "./pagination.ts";
import passwordInputWrapperTheme from "./passwordInput.ts";
import popoverTheme from "./popover.ts";
import scrollAreaTheme from "./scrollArea.ts";
import selectTheme from "./select.ts";
import sliderTheme from "./slider.ts";
import spoilerTheme from "./spoiler.ts";
import switchTheme from "./switch.ts";
import tableTheme from "./table.ts";
import tabsTheme from "./tabs.ts";
import textTheme from "./text.ts";
import tooltipTheme from "./tooltip.ts";

export const theme: MantineThemeOverride = {
  colors,
  fontFamily: "Poppins",
  headings: {
    sizes: {
      h1: { fontWeight: "600", fontSize: rem(25), lineHeight: "1.5" },
      h2: { fontWeight: "600", fontSize: rem(20), lineHeight: "1.5" },
      h3: { fontWeight: "500", fontSize: rem(22), lineHeight: "1.5" },
    },
  },
  components: {
    Accordion: accordionTheme(),
    Input: inputWrapperTheme(),
    TextInput: inputWrapperTheme(),
    Text: textTheme(),
    PasswordInput: passwordInputWrapperTheme(),
    NumberInput: inputWrapperTheme(),
    InputWrapper: inputWrapperTheme(),
    Button: buttonTheme(),
    Table: tableTheme(),
    Pagination: paginationTheme(),
    Select: selectTheme(),
    NavLink: navLinkTheme(),
    Modal: modalTheme(),
    AppShell: appShellTheme(),
    ScrollArea: scrollAreaTheme(),
    Notification: notificationTheme(),
    MultiSelect: multiSelectTheme(),
    DatePickerInput: dateInputTheme(),
    Calendar: calendarTheme(),
    DatePicker: calendarTheme(),
    Tabs: tabsTheme(),
    ActionIcon: actionIconTheme(),
    Breadcrumbs: breadcrumbsTheme(),
    Dropzone: dropzoneTheme(),
    Spoiler: spoilerTheme(),
    Tooltip: tooltipTheme(),
    Popover: popoverTheme(),
    Badge: badgeTheme(),
    Switch: switchTheme(),
    Checkbox: checkboxTheme(),
    Slider: sliderTheme(),
    Code: codeTheme(),
  },
};
